import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import UiQuickSettings from '@/components/ui/UiQuickSettings.vue';
import MainSection from '@/components/pages/home/MainSection.vue';
import HowItWorksSection from '@/components/pages/home/HowItWorksSection.vue';
import WhyUs from '@/components/pages/home/WhyUs.vue';
import BennefitsSection from '@/components/pages/home/BennefitsSection.vue';
import WorldMetrics from '@/components/pages/home/WorldMetrics.vue';
import FAQSection from '@/components/pages/home/FAQSection.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(UiQuickSettings),
    _createVNode(MainSection),
    _createVNode(WorldMetrics),
    _createVNode(HowItWorksSection),
    _createVNode(WhyUs),
    _createVNode(BennefitsSection),
    _createVNode(FAQSection)
  ]))
}
}

})